import React from "react";
import "../styles/app.scss";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import AppHeader from "../components/header/Header";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import AppFooter from "../components/footer/AppFooter";
import { StoreProvider } from "../context/store/storeContext";
import appRoutes from "../route/AppRouter";
import NotFound from "../pages/404";
import ErrorBoundary from "../components/ErrorBoundary";
import ScrollToTop from "../components/ScrollToTop";

if (process.env.REACT_APP_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_PUBLIC_SENTRY_DSN,
    release: "yomafleet-easylease",
    // debug: process.env.REACT_APP_ENV === 'production' ? false: true,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const App = () => {
  return (
    <div className="app">
      <section id="appContent">
        {/* <StoreProvider>
          <CookiesProvider> */}

        <BrowserRouter basename="/">
          <StoreProvider>
            <AppHeader />
            <ErrorBoundary>
              <ScrollToTop />
              <Switch>
                {appRoutes.map((route, key) => {
                  return (
                    <Route
                      key={key}
                      path={route?.path}
                      component={route?.component}
                      exact={route?.exact}
                    />
                  );
                })}
                <Route path="*" component={NotFound}></Route>
              </Switch>
            </ErrorBoundary>
            <AppFooter />
          </StoreProvider>
        </BrowserRouter>
        {/* </CookiesProvider>
        </StoreProvider> */}
      </section>
      {/* <section id="appContent">{renderRoutes(route.routes)}</section> */}
    </div>
  );
};

export default App; //{ component: App };
